import React, { FC } from 'react';
import { TableBody, TableHead, TableRow, TableCell, TextField, TableContainer, makeStyles, MenuItem } from '@material-ui/core';
import BodyRow from './component/BodyRow';
import { HeaderRow, TableCellHead, TableCustom } from 'components/Table';
import { dummyPurchaseInvoice } from 'utils/dummy';

interface Props {
  isLoadingData: boolean;
  count: number;
  currentPage: number;
  purchaseInvoices?: PurchaseInvoiceModel[];
  order: 'asc' | 'desc';
  orderBy: string;
  indexCollapse: number;
  openCollapse: boolean;
  name: string;
  statusPayment: string;
  purchaseInvoiceId: string;
  collapseLoading: boolean;
  isNotAllowCreate: boolean;
  statusInvoice: string;
  setStatusInvoice: React.Dispatch<React.SetStateAction<string>>;
  setName: React.Dispatch<React.SetStateAction<string>>;
  setStatusPayment: React.Dispatch<React.SetStateAction<string>>;
  setInvoiceId: React.Dispatch<React.SetStateAction<string>>;
  setOrder: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>;
  setOrderBy: React.Dispatch<React.SetStateAction<string>>;
  handleConfirmationDelete: (id: number) => React.MouseEventHandler;
  handleOpenCollapse: (id: number) => React.MouseEventHandler;
}

const useStyles = makeStyles({
  cellStartId: {
    width: '5%'
  },
  cellTable: {
    width: '17%'
  },
  cellTable3: {
    width: '13%'
  }
});

const PurchaseInvoiceTable: FC<Props> = props => {
  const classes = useStyles();
  const {
    isLoadingData,
    purchaseInvoices,
    order,
    orderBy,
    indexCollapse,
    openCollapse,
    name,
    purchaseInvoiceId,
    collapseLoading,
    isNotAllowCreate,
    setName,
    setInvoiceId,
    setOrder,
    setOrderBy,
    handleConfirmationDelete,
    handleOpenCollapse,
    statusInvoice,
    setStatusInvoice
  } = props;

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <TableContainer>
      <TableCustom>
        <TableHead>
          <HeaderRow
            key={1}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            headers={[
              { label: '#' },
              { id: 'no', label: 'No', sort: true },
              { id: 'invoiceNumber', label: 'Nomor Invoice', sort: true },
              { id: 'invoiceNumberSupplier', label: 'No Invoice Supplier', sort: true, align: 'center' },
              { id: 'name', label: 'Nama Supplier', sort: true },
              { id: 'totalPrice', label: 'Total Harga', sort: true, align: 'right' },
              // { id: 'totalItem', label: 'Total Item', sort: true, align: 'center' },
              { id: 'orderDate', label: 'TANGGAL INVOICE', sort: true, align: 'center' },

              // { id: 'statusInvoice', label: 'STATUS', sort: true, align: 'center' },
              { label: isNotAllowCreate ? '' : 'Aksi' }
            ]}
          />
          <TableRow key={2}>
            <TableCellHead variant='head' className={classes.cellStartId}></TableCellHead>
            <TableCellHead variant='head' className={classes.cellStartId}></TableCellHead>
            <TableCellHead variant='head' className={classes.cellStartId}>
              <TextField
                placeholder='No Invoice'
                id='purchaseInvoiceId'
                value={purchaseInvoiceId}
                onChange={event => setInvoiceId(event.target.value)}
              />
            </TableCellHead>
            <TableCellHead variant='head' className={classes.cellTable}></TableCellHead>
            <TableCellHead variant='head' className={classes.cellTable}>
              <TextField id='name' placeholder='Nama Supplier' value={name} onChange={event => setName(event.target.value)} />
            </TableCellHead>
            {/* <TableCellHead align='center' variant='head' /> */}
            <TableCellHead align='center' variant='head' />
            <TableCellHead align='center' variant='head' />
            {/* <TableCellHead align='center' variant='head'>
              <TextField
                select
                id='statusOrder'
                value={statusInvoice}
                autoComplete='off'
                onChange={event => setStatusInvoice(event.target.value as string)}
              >
                <MenuItem key={3} value='CONFIRMATION' selected>
                  Konfirmasi
                </MenuItem>
                <MenuItem key={4} value='CANCEL'>
                  Batal
                </MenuItem>
              </TextField>
            </TableCellHead> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoadingData ? (
            [0, 1, 2, 3].map(index => (
              <BodyRow
                number={index}
                key={index}
                index={index}
                indexCollapse={indexCollapse}
                openCollapse={openCollapse}
                isNotAllowCreate={isNotAllowCreate}
                isLoading={isLoadingData}
                statusInvoice={statusInvoice}
                purchaseInvoice={dummyPurchaseInvoice}
                collapseLoading={collapseLoading}
                onDelete={handleConfirmationDelete(0)}
                handleOpenCollapse={handleOpenCollapse(index)}
              />
            ))
          ) : purchaseInvoices && purchaseInvoices.length > 0 ? (
            purchaseInvoices.map((value, index) => (
              <BodyRow
                key={index}
                number={index}
                index={value.id}
                indexCollapse={indexCollapse}
                openCollapse={openCollapse}
                isLoading={isLoadingData}
                isNotAllowCreate={isNotAllowCreate}
                purchaseInvoice={value}
                statusInvoice={statusInvoice}
                collapseLoading={collapseLoading}
                onDelete={handleConfirmationDelete(value.id)}
                handleOpenCollapse={handleOpenCollapse(value.id)}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} align='center'>
                Data Tidak Tersedia.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </TableCustom>
    </TableContainer>
  );
};

export default PurchaseInvoiceTable;
